import { useMutation, useQuery } from "react-query";
import {
  getCustomFields,
  createCustomField,
  updateCustomField,
  deactivateCustomField,
  reorderCustomFields,
} from "../api/customFields";
import { UdfEntityType } from "../types/CustomFields";
import { queryClient } from "./client";

const QUERY_KEY = "getCustomFields";

export function useGetCustomFields(entityType?: UdfEntityType) {
  return useQuery({
    queryKey: [QUERY_KEY, entityType],
    queryFn: () => getCustomFields(entityType),
  });
}

export function useCreateCustomField() {
  return useMutation({
    mutationFn: createCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
    },
  });
}

export function useUpdateCustomField() {
  return useMutation({
    mutationFn: ({
      id,
      dto,
    }: {
      id: string;
      dto: Parameters<typeof updateCustomField>[1];
    }) => updateCustomField(id, dto),
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
    },
  });
}

export function useDeactivateCustomField() {
  return useMutation({
    mutationFn: deactivateCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
    },
  });
}

export function useReorderCustomFields() {
  return useMutation({
    mutationFn: ({
      entityType,
      orderedIds,
    }: {
      entityType: UdfEntityType;
      orderedIds: string[];
    }) => reorderCustomFields(entityType, orderedIds),
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY);
    },
  });
}
